import { useEffect, useState } from "react";
import { useForm, useFormState } from "react-hook-form";

import Validations from "@src/utility/helpers/validations";
import { object } from "yup";
import useAxios from "@src/utility/hooks/use-axios";
import { useParams } from "react-router-dom";
import useSearchParams from "@src/utility/hooks/use-search-params";
import { yupResolver } from "@hookform/resolvers/yup";

const defaultValues = {
    name  : "",
    type  : "",
    status: "active"
};

const useTags = () => {
    const { platformId } = useParams();
    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });
    const { axiosInstance: upsertAxiosInstance, loading: updateLoading } =
    useAxios({ base: "panel" });

    const [data, setData] = useState({ tags: [], pagination: {} });
    const [queryParams, setQueryParams] = useState({});
    const [modalConfig, setModalConfig] = useState({ isOpen: false, row: {} });
    const { requiredValidation, minMaxRequiredString } = Validations();
    const { getSearchParams, createSearchParams } = useSearchParams();
    const [activeAccordion, setActiveAccordion] = useState(getSearchParams("tab") || "people");

    const handleActiveAccordion = (tab) => {
        setActiveAccordion(tab);
        createSearchParams("tab", tab);
    };
    const handleModalConfig = (row = {}) => {
        setModalConfig(prev => ({ row, isOpen: !prev.isOpen }));
    };

    const validationSchema = object().shape({
        name: minMaxRequiredString({ name: "Name", min: 3, max: 32 }),
        type: requiredValidation({ name: "type" })
    });
    
    const methods = useForm({
        defaultValues,
        resolver: yupResolver(validationSchema)
    });
    const { control, handleSubmit, reset } = methods;
    const { isDirty } = useFormState({ control });

    const getTags = async () => {
        const { data } = await axiosInstance.get(`/tags/${platformId}`);
    
        setData({
            tags      : data,
            pagination: null 
        });
    };
    
    const handleRowActions = async (action, row = defaultValues, type) => {
        if (action === "delete") {
            await axiosInstance.delete(`/tags/${platformId}/${row._id}`);
            getTags(); 
            return;
        }
        const formattedRow = {
            ...row,
            type
        };
        handleModalConfig(formattedRow);
        reset(formattedRow);
    };

    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getTags();
            handleActiveAccordion(getSearchParams("tab") || "people");
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    const onSubmit = () => {
        handleSubmit(async data => {
            const payload = {
                name  : data.name,
                type  : data.type,
                status: "active"

            };
            if (!modalConfig.row._id) {
                await upsertAxiosInstance.post(`/tags/${platformId}`, payload);
            } else {
                await upsertAxiosInstance.patch(
                    `/tags/${platformId}/${modalConfig.row._id}`,
                    payload
                );
            }
            getTags();
            handleModalConfig();
            handleActiveAccordion(data.type);

        })();
    };

    return {
        data,
        loading,
        getTags,
        setQueryParams,
        handleModalConfig,
        modalConfig,
        isOpen: modalConfig.isOpen,
        handleRowActions,
        onSubmit,
        isDirty,
        updateLoading,
        methods,
        handleActiveAccordion,
        activeAccordion
    };
};

export default useTags;